import { createLogic } from "redux-logic";
import { LOGOUT_USER } from "../types";
import { getAuth, signOut, signInAnonymously } from "firebase/auth";

const auth = getAuth();

const logoutUserLogic = createLogic({
	type: LOGOUT_USER,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		signOut(auth)
			.then(() => {
				if (window.location?.pathname?.includes("/dashboard")) {
					signInAnonymously(auth);
				}
			});
		//TODO -> Send message and reroute
		// dispatch(ControlPanelActions.displayQuickMessage(action.message, "success", "user-lock"));
		done();
	},
});

export default [logoutUserLogic];
